import React, {useContext} from 'react';
import { AuthContext } from '../AuthContext';
import { handleAddLicenseKeyClicked } from '../utilityFunctions/firestoreUtilities';

function TopNavBar({
    setShowLoginModal,
    setShowSignupModal
}) {

    const { authUser, handleSignOut } = useContext(AuthContext);    

    const handleAddLicenseKey = () => {
        handleAddLicenseKeyClicked();
    }

    return (
        <div className='w-full flex flex-row justify-between items-center px-4 sm:px-8 lg:px-12 py-3 sm:py-4 bg-indigo-200 border-b border-gray-500 fixed top-0 left-0 z-50'>
            <h1
                className="cursor-pointer text-base sm:text-lg font-bold text-indigo-900"
                onClick={() => window.location.href = '/'}
            >GrantMagic</h1>            
            {authUser ? (
                // User is authenticated - show feedback, help, and account buttons
                <div className='flex flex-row gap-1 sm:gap-2 text-xs'>                    
                    <button 
                        className='bg-gray-200 text-gray-500 px-2 py-1 sm:px-3 sm:py-1 rounded-md text-xs hover:bg-gray-300'
                        onClick={() => {
                            handleAddLicenseKey();
                        }}
                    >
                        Add License Key
                    </button>
                    <button 
                        className='bg-gray-200 text-gray-500 px-2 py-1 sm:px-3 sm:py-1 rounded-md text-xs hover:bg-gray-300'
                        onClick={() => window.open('https://tally.so/r/mDVa5j', '_blank')}
                    >Help</button>
                    <button 
                        className='bg-gray-200 text-gray-500 px-2 py-1 sm:px-3 sm:py-1 rounded-md text-xs hover:bg-gray-300'
                        onClick={handleSignOut}
                    >Logout</button>
                </div>
            ) : (
                // User is not authenticated - show sign in and sign up buttons
                <div className='flex flex-row gap-1 sm:gap-2 text-xs'>
                    <button 
                        className='bg-gray-200 text-gray-500 px-2 py-1 sm:px-3 sm:py-1 rounded-md text-xs hover:bg-gray-300' 
                        onClick={() => {
                            setShowLoginModal(true);
                        }}
                    >Sign In</button>
                    <button 
                        className='bg-indigo-500 text-white px-2 py-1 sm:px-3 sm:py-1 rounded-md text-xs hover:bg-indigo-600' 
                        onClick={() => {
                            setShowSignupModal(true);
                        }}>Sign Up</button>
                </div>
            )}
        </div>
    );
}

export default TopNavBar;